(() => {
  const frameStyles = {
    none: 'transparent',
    black: '#171717',
    white: '#e8e6e2',
    wood: '#b6814f'
  };

  const parseSize = (value) => {
    const parts = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!parts) return null;
    const width = Number(parts[1].replace(',', '.'));
    const height = Number(parts[2].replace(',', '.'));
    if (!width || !height) return null;
    return { width, height, longest: Math.max(width, height) };
  };

  const activateMockup = (root) => {
    root.querySelectorAll('[data-product-media]').forEach((media) => {
      const active = media.dataset.mediaId === 'mockup';
      media.hidden = !active;
      media.classList.toggle('is-active', active);
    });
    root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      const active = thumb.dataset.mediaTarget === 'mockup';
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  };

  const restartAnimation = (print) => {
    if (!print) return;
    print.classList.remove('is-changing');
    void print.offsetWidth;
    print.classList.add('is-changing');
  };

  const initMockup = (root) => {
    const mockup = root.querySelector('[data-product-mockup]');
    const print = root.querySelector('[data-mockup-print]');
    const frameConfig = root.querySelector('[data-frame-config]');
    if (!mockup || !print || !frameConfig || mockup.dataset.initialized === 'true') return;
    mockup.dataset.initialized = 'true';

    const sizeInputs = [...root.querySelectorAll('[data-mockup-size]')];
    const frameInputs = [...frameConfig.querySelectorAll('[data-frame-key]')];
    const matInputs = [...frameConfig.querySelectorAll('[data-mat-size]')];
    let initialized = false;

    const animate = () => {
      activateMockup(root);
      if (initialized) restartAnimation(print);
    };

    const syncSize = () => {
      const selected = sizeInputs.find((input) => input.checked) || sizeInputs[0];
      const parsed = parseSize(selected?.value);
      if (!parsed) return;

      const available = sizeInputs.map((input) => parseSize(input.value)).filter(Boolean);
      const maximum = Math.max(...available.map((size) => size.longest));
      const ratio = parsed.width / parsed.height;
      const width = ratio < .85 ? 36 : ratio > 1.15 ? 42 : 39;
      const cameraScale = Math.min(4.8, Math.max(1, Math.pow(maximum / parsed.longest, .86)));

      mockup.style.setProperty('--jq-mockup-width', `${width.toFixed(2)}%`);
      mockup.style.setProperty('--jq-mockup-ratio', `${parsed.width} / ${parsed.height}`);
      mockup.style.setProperty('--jq-camera-scale', cameraScale.toFixed(3));
      mockup.dataset.size = selected.value;
      mockup.dataset.cameraScale = cameraScale.toFixed(3);
      animate();
    };

    const syncFrame = () => {
      const frameInput = frameInputs.find((input) => input.checked) || frameInputs[0];
      const frameKey = frameInput?.dataset.frameKey || 'black';
      const withoutFrame = frameKey === 'none';

      matInputs.forEach((input) => {
        if (input.dataset.matSize !== '0') input.disabled = withoutFrame;
      });
      if (withoutFrame) {
        const withoutMat = matInputs.find((input) => input.dataset.matSize === '0');
        if (withoutMat) withoutMat.checked = true;
      }

      const matSize = matInputs.find((input) => input.checked)?.dataset.matSize || '0';
      const frameShell = mockup.querySelector('.jq-mockup__frame-shell');

      mockup.dataset.frameKey = frameKey;
      frameConfig.dataset.frameKey = frameKey;
      mockup.dataset.matSize = matSize;
      mockup.style.setProperty('--jq-frame-color', frameStyles[frameKey] || frameStyles.black);
      if (frameShell) {
        // Frame choices are intentionally rendered as clean, solid colors.
        frameShell.style.backgroundImage = 'none';
      }
      mockup.style.setProperty('--jq-frame-width', withoutFrame ? '0px' : 'clamp(8px,1vw,15px)');
      mockup.style.setProperty('--jq-mat-width', withoutFrame ? '0%' : matSize === '6' ? '9%' : matSize === '3' ? '5%' : '0%');

      if (initialized) {
        const url = new URL(window.location.href);
        url.searchParams.delete('frameGroup');
        url.searchParams.set('frameType', frameKey);
        url.searchParams.set('matSize', matSize);
        window.history.replaceState({}, '', url);
      }
      animate();
    };

    const hydrateFromUrl = () => {
      const params = new URL(window.location.href).searchParams;
      const requestedFrame = params.get('frameType');
      const frameInput = frameInputs.find((input) => input.dataset.frameKey === requestedFrame);
      if (frameInput) frameInput.checked = true;

      const requestedMat = params.get('matSize');
      const matInput = matInputs.find((input) => input.dataset.matSize === requestedMat && !input.disabled);
      if (matInput) matInput.checked = true;
    };

    sizeInputs.forEach((input) => input.addEventListener('change', syncSize));
    frameInputs.forEach((input) => input.addEventListener('change', syncFrame));
    matInputs.forEach((input) => input.addEventListener('change', syncFrame));

    hydrateFromUrl();
    syncSize();
    syncFrame();
    initialized = true;
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-product-root]').forEach(initMockup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
